var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import Joyride, { ACTIONS, STATUS, EVENTS } from "react-joyride";
import tourTracking from "@irati-tracking/tour";
import { perkbox } from "@irati/ui/src/global/colors";
import CustomToolTip from "./CustomToolTip";
import CustomBeacon from "./CustomBeacon";
var customStyles = {
    options: {
        primaryColor: perkbox.darkBlue
    }
};
// See ./README.md for implementation suggestion and doc links
var PerkboxTour = /** @class */ (function (_super) {
    __extends(PerkboxTour, _super);
    function PerkboxTour() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.customCallback = function (data) {
            var status = data.status, action = data.action, type = data.type;
            var _a = _this.props, onStart = _a.onStart, onComplete = _a.onComplete, onClose = _a.onClose, tourPrefix = _a.tourPrefix, steps = _a.steps;
            if (action === ACTIONS.START && type === EVENTS.TOUR_START) {
                tourTracking.tourStart(tourPrefix, steps.length);
                if (onStart)
                    onStart();
            }
            if (status === STATUS.FINISHED && type === EVENTS.STEP_AFTER) {
                tourTracking.tourComplete(tourPrefix, steps.length);
                if (onComplete)
                    onComplete();
            }
            if (action === ACTIONS.PREV && type === EVENTS.STEP_BEFORE) {
                tourTracking.tourPrevious(tourPrefix, data.index, data.size);
            }
            if (action === ACTIONS.NEXT && type === EVENTS.STEP_BEFORE) {
                tourTracking.tourNext(tourPrefix, data.index, data.size);
            }
            if (action === ACTIONS.CLOSE && type === EVENTS.STEP_BEFORE) {
                tourTracking.tourClose(tourPrefix, data.index, data.size);
                if (onClose)
                    onClose();
            }
        };
        return _this;
    }
    PerkboxTour.prototype.render = function () {
        return (React.createElement(Joyride, __assign({ beaconComponent: CustomBeacon, tooltipComponent: CustomToolTip, continuous: true, scrollToFirstStep: true, callback: this.customCallback, showProgress: true, showSkipButton: true }, this.props, { styles: customStyles })));
    };
    return PerkboxTour;
}(PureComponent));
export default PerkboxTour;
